import { render, staticRenderFns } from "./TabelaPagamentosAvulsos.vue?vue&type=template&id=0266a56a&scoped=true&"
import script from "./TabelaPagamentosAvulsos.vue?vue&type=script&lang=js&"
export * from "./TabelaPagamentosAvulsos.vue?vue&type=script&lang=js&"
import style0 from "./TabelaPagamentosAvulsos.vue?vue&type=style&index=0&id=0266a56a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0266a56a",
  null
  
)

export default component.exports